/* eslint-disable jira/filename-case */
import { useCallback, useEffect, useState } from 'react';
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { userPreferenceAPI } from '@jira/platform__services-user-preferences/src/utils/index.tsx';

const JIRA_EDITION_AWARENESS_FOR_STANDARD_TO_PREMIUM_PACKAGE_NAME =
	'jiraEditionAwarenessForStandardToPremium' as const;

const JIRA_EDITION_AWARENESS_FOR_STANDARD_TO_PREMIUM_PILL_DISMISSED =
	'jira.user.theme.standard-to-premium-ea-pill.dismissed' as const;

export const setEditionAwarenessPillDismissed = async (value: boolean): Promise<void> => {
	try {
		await userPreferenceAPI.set(
			JIRA_EDITION_AWARENESS_FOR_STANDARD_TO_PREMIUM_PILL_DISMISSED,
			value,
		);
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (err: any) {
		fireErrorAnalytics({
			error: err,
			meta: {
				id: 'setEditionAwarenessPillDismissed',
				packageName: JIRA_EDITION_AWARENESS_FOR_STANDARD_TO_PREMIUM_PACKAGE_NAME,
			},
		});
	}
};

export const fetchEditionAwarenessPillDismissed = async (): Promise<boolean | null | undefined> => {
	try {
		return await userPreferenceAPI.get(
			JIRA_EDITION_AWARENESS_FOR_STANDARD_TO_PREMIUM_PILL_DISMISSED,
		);
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (err: any) {
		if (err.statusCode === 404) {
			return null;
		}

		fireErrorAnalytics({
			error: err,
			meta: {
				id: 'fetchEditionAwarenessPillDismissed',
				packageName: JIRA_EDITION_AWARENESS_FOR_STANDARD_TO_PREMIUM_PACKAGE_NAME,
			},
		});

		return undefined;
	}
};

export const useEditionAwarenessStandardToPremium = (
	shouldFetchDismissalState: boolean,
): {
	isLoading: boolean;
	isDismissed: boolean;
	handleDismiss: () => void;
} => {
	const [isLoading, setIsLoading] = useState(shouldFetchDismissalState);
	// If they are eligible, we set to true as default, so we can wait for the real value to show keep hidden
	// If not eligible, even if is not read, we are setting as false, as it can't be dismissed
	const [isDismissed, setIsDismissed] = useState(shouldFetchDismissalState);

	useEffect(() => {
		if (shouldFetchDismissalState) {
			fetchEditionAwarenessPillDismissed().then((result) => {
				if (result !== undefined) {
					setIsDismissed(!!result);
				}
				setIsLoading(false);
			});
		}
	}, [shouldFetchDismissalState]);

	const handleDismiss = useCallback((): void => {
		setIsDismissed(true);
		setEditionAwarenessPillDismissed(true);
	}, []);

	return { isLoading, isDismissed, handleDismiss };
};
